import { forwardRef } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Typography } from '@material-ui/core'

const TransitionComponent = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

const ConfirmationModal = ({ cancelButtonText, approveButtonText, content, handleClose, open, handleApprove }) => (
  <>
    <Dialog
      open={open}
      TransitionComponent={TransitionComponent}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle id='alert-dialog-slide-title' style={{ color: 'red' }}>
        <Typography variant='h5'>Confirmation</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          {cancelButtonText}
        </Button>
        <Button onClick={handleApprove} color='primary'>
          {approveButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  </>
)

ConfirmationModal.defaultProps = {
  cancelButtonText: 'Cancel',
  approveButtonText: 'Ok',
  open: false
}

export default ConfirmationModal
